const _A = "Arn";
const _AA = "AliasArn";
const _AD = "AttestationDocument";
const _AEE = "AlreadyExistsException";
const _AKI = "AccessKeyId";
const _AL = "AliasList";
const _ALE = "AliasListEntry";
const _AN = "AliasName";
const _AWSAI = "AWSAccountId";
const _Al = "Aliases";
const _BPLSC = "BypassPolicyLockoutSafetyCheck";
const _C = "Constraints";
const _CA = "CreateAlias";
const _CAR = "CreateAliasRequest";
const _CB = "CiphertextBlob";
const _CCKS = "ConnectCustomKeyStore";
const _CCKSR = "ConnectCustomKeyStoreRequest";
const _CCKSRo = "ConnectCustomKeyStoreResponse";
const _CCKSRr = "CreateCustomKeyStoreRequest";
const _CCKSRre = "CreateCustomKeyStoreResponse";
const _CCKSr = "CreateCustomKeyStore";
const _CD = "CreationDate";
const _CE = "ConflictException";
const _CEC = "ConnectionErrorCode";
const _CFR = "CiphertextForRecipient";
const _CG = "CreateGrant";
const _CGR = "CreateGrantRequest";
const _CGRr = "CreateGrantResponse";
const _CHCI = "CloudHsmClusterId";
const _CHCICE = "CloudHsmClusterInvalidConfigurationException";
const _CHCIUE = "CloudHsmClusterInUseException";
const _CHCNAE = "CloudHsmClusterNotActiveException";
const _CHCNFE = "CloudHsmClusterNotFoundException";
const _CHCNRE = "CloudHsmClusterNotRelatedException";
const _CK = "CreateKey";
const _CKD = "CancelKeyDeletion";
const _CKDR = "CancelKeyDeletionRequest";
const _CKDRa = "CancelKeyDeletionResponse";
const _CKMI = "CurrentKeyMaterialId";
const _CKR = "CreateKeyRequest";
const _CKRr = "CreateKeyResponse";
const _CKS = "CustomKeyStores";
const _CKSHCMKE = "CustomKeyStoreHasCMKsException";
const _CKSI = "CustomKeyStoreId";
const _CKSISE = "CustomKeyStoreInvalidStateException";
const _CKSL = "CustomKeyStoresList";
const _CKSLE = "CustomKeyStoresListEntry";
const _CKSN = "CustomKeyStoreName";
const _CKSNFE = "CustomKeyStoreNotFoundException";
const _CKSNIUE = "CustomKeyStoreNameInUseException";
const _CKST = "CustomKeyStoreType";
const _CMKS = "CustomerMasterKeySpec";
const _CS = "ConnectionState";
const _Co = "Connectivity";
const _D = "Description";
const _DA = "DeleteAlias";
const _DAR = "DeleteAliasRequest";
const _DCKS = "DeleteCustomKeyStore";
const _DCKSR = "DeleteCustomKeyStoreRequest";
const _DCKSRe = "DeleteCustomKeyStoreResponse";
const _DCKSRes = "DescribeCustomKeyStoresRequest";
const _DCKSResc = "DescribeCustomKeyStoresResponse";
const _DCKSRi = "DisconnectCustomKeyStoreRequest";
const _DCKSRis = "DisconnectCustomKeyStoreResponse";
const _DCKSe = "DescribeCustomKeyStores";
const _DCKSi = "DisconnectCustomKeyStore";
const _DD = "DeletionDate";
const _DE = "DisabledException";
const _DEA = "DestinationEncryptionAlgorithm";
const _DEC = "DestinationEncryptionContext";
const _DIKM = "DeleteImportedKeyMaterial";
const _DIKMR = "DeleteImportedKeyMaterialRequest";
const _DIKMRe = "DeleteImportedKeyMaterialResponse";
const _DK = "DescribeKey";
const _DKI = "DestinationKeyId";
const _DKMI = "DestinationKeyMaterialId";
const _DKR = "DescribeKeyRequest";
const _DKRR = "DisableKeyRotationRequest";
const _DKRe = "DescribeKeyResponse";
const _DKRi = "DisableKeyRequest";
const _DKRis = "DisableKeyRotation";
const _DKi = "DisableKey";
const _DR = "DryRun";
const _DROE = "DryRunOperationException";
const _DRe = "DecryptRequest";
const _DRec = "DecryptResponse";
const _DSS = "DeriveSharedSecret";
const _DSSR = "DeriveSharedSecretRequest";
const _DSSRe = "DeriveSharedSecretResponse";
const _DTE = "DependencyTimeoutException";
const _De = "Decrypt";
const _E = "Enabled";
const _EA = "EncryptionAlgorithm";
const _EAn = "EncryptionAlgorithms";
const _EC = "EncryptionContext";
const _ECE = "EncryptionContextEquals";
const _ECS = "EncryptionContextSubset";
const _EITE = "ExpiredImportTokenException";
const _EK = "EnableKey";
const _EKM = "EncryptedKeyMaterial";
const _EKR = "EnableKeyRequest";
const _EKRR = "EnableKeyRotationRequest";
const _EKRn = "EnableKeyRotation";
const _EM = "ExpirationModel";
const _ER = "EncryptRequest";
const _ERn = "EncryptResponse";
const _En = "Encrypt";
const _G = "Grants";
const _GC = "GrantConstraints";
const _GDK = "GenerateDataKey";
const _GDKP = "GenerateDataKeyPair";
const _GDKPR = "GenerateDataKeyPairRequest";
const _GDKPRe = "GenerateDataKeyPairResponse";
const _GDKPWP = "GenerateDataKeyPairWithoutPlaintext";
const _GDKPWPR = "GenerateDataKeyPairWithoutPlaintextRequest";
const _GDKPWPRe = "GenerateDataKeyPairWithoutPlaintextResponse";
const _GDKR = "GenerateDataKeyRequest";
const _GDKRe = "GenerateDataKeyResponse";
const _GDKWP = "GenerateDataKeyWithoutPlaintext";
const _GDKWPR = "GenerateDataKeyWithoutPlaintextRequest";
const _GDKWPRe = "GenerateDataKeyWithoutPlaintextResponse";
const _GI = "GrantId";
const _GKP = "GetKeyPolicy";
const _GKPR = "GetKeyPolicyRequest";
const _GKPRe = "GetKeyPolicyResponse";
const _GKRS = "GetKeyRotationStatus";
const _GKRSR = "GetKeyRotationStatusRequest";
const _GKRSRe = "GetKeyRotationStatusResponse";
const _GL = "GrantList";
const _GLE = "GrantListEntry";
const _GM = "GenerateMac";
const _GMR = "GenerateMacRequest";
const _GMRe = "GenerateMacResponse";
const _GP = "GranteePrincipal";
const _GPFI = "GetParametersForImport";
const _GPFIR = "GetParametersForImportRequest";
const _GPFIRe = "GetParametersForImportResponse";
const _GPK = "GetPublicKey";
const _GPKR = "GetPublicKeyRequest";
const _GPKRe = "GetPublicKeyResponse";
const _GR = "GenerateRandom";
const _GRR = "GenerateRandomRequest";
const _GRRe = "GenerateRandomResponse";
const _GT = "GrantTokens";
const _GTr = "GrantToken";
const _I = "Id";
const _IA = "IssuingAccount";
const _IAE = "InvalidArnException";
const _IANE = "InvalidAliasNameException";
const _ICE = "InvalidCiphertextException";
const _IGIE = "InvalidGrantIdException";
const _IGTE = "InvalidGrantTokenException";
const _IITE = "InvalidImportTokenException";
const _IKE = "IncorrectKeyException";
const _IKM = "IncludeKeyMaterial";
const _IKME = "IncorrectKeyMaterialException";
const _IKMR = "ImportKeyMaterialRequest";
const _IKMRm = "ImportKeyMaterialResponse";
const _IKMm = "ImportKeyMaterial";
const _IKUE = "InvalidKeyUsageException";
const _IME = "InvalidMarkerException";
const _IS = "ImportState";
const _IT = "ImportToken";
const _ITAE = "IncorrectTrustAnchorException";
const _ITm = "ImportType";
const _K = "Keys";
const _KA = "KeyArn";
const _KAA = "KeyAgreementAlgorithm";
const _KAAe = "KeyAgreementAlgorithms";
const _KEA = "KeyEncryptionAlgorithm";
const _KI = "KeyId";
const _KL = "KeyList";
const _KLE = "KeyListEntry";
const _KM = "KeyMetadata";
const _KMD = "KeyMaterialDescription";
const _KMI = "KeyMaterialId";
const _KMS = "KeyMaterialState";
const _KMSIE = "KMSInternalException";
const _KMSIME = "KMSInvalidMacException";
const _KMSISE = "KMSInvalidSignatureException";
const _KMSISEn = "KMSInvalidStateException";
const _KMe = "KeyManager";
const _KO = "KeyOrigin";
const _KPS = "KeyPairSpec";
const _KRE = "KeyRotationEnabled";
const _KS = "KeySpec";
const _KSP = "KeyStorePassword";
const _KSPT = "KeyStorePasswordType";
const _KSe = "KeyState";
const _KU = "KeyUsage";
const _KUE = "KeyUnavailableException";
const _L = "Limit";
const _LA = "ListAliases";
const _LAR = "ListAliasesRequest";
const _LARi = "ListAliasesResponse";
const _LEE = "LimitExceededException";
const _LG = "ListGrants";
const _LGR = "ListGrantsRequest";
const _LGRi = "ListGrantsResponse";
const _LK = "ListKeys";
const _LKP = "ListKeyPolicies";
const _LKPR = "ListKeyPoliciesRequest";
const _LKPRi = "ListKeyPoliciesResponse";
const _LKR = "ListKeysRequest";
const _LKRR = "ListKeyRotationsRequest";
const _LKRRi = "ListKeyRotationsResponse";
const _LKRi = "ListKeysResponse";
const _LKRis = "ListKeyRotations";
const _LRG = "ListRetirableGrants";
const _LRGR = "ListRetirableGrantsRequest";
const _LRT = "ListResourceTags";
const _LRTR = "ListResourceTagsRequest";
const _LRTRi = "ListResourceTagsResponse";
const _LUD = "LastUpdatedDate";
const _M = "Marker";
const _MA = "MacAlgorithm";
const _MAa = "MacAlgorithms";
const _MPDE = "MalformedPolicyDocumentException";
const _MR = "MultiRegion";
const _MRC = "MultiRegionConfiguration";
const _MRK = "MultiRegionKey";
const _MRKL = "MultiRegionKeyList";
const _MRKT = "MultiRegionKeyType";
const _MT = "MessageType";
const _MV = "MacValid";
const _Ma = "Mac";
const _Me = "Message";
const _N = "Name";
const _NCKSN = "NewCustomKeyStoreName";
const _NFE = "NotFoundException";
const _NM = "NextMarker";
const _NOB = "NumberOfBytes";
const _NRD = "NextRotationDate";
const _O = "Operations";
const _ODRSD = "OnDemandRotationStartDate";
const _Or = "Origin";
const _P = "Policy";
const _PDWID = "PendingDeletionWindowInDays";
const _PK = "PublicKey";
const _PKCB = "PrivateKeyCiphertextBlob";
const _PKP = "PrivateKeyPlaintext";
const _PKPR = "PutKeyPolicyRequest";
const _PKPu = "PutKeyPolicy";
const _PKr = "PrimaryKey";
const _PN = "PolicyName";
const _PNo = "PolicyNames";
const _PR = "PrimaryRegion";
const _PT = "PlaintextType";
const _PVT = "ParametersValidTo";
const _PWID = "PendingWindowInDays";
const _Pl = "Plaintext";
const _R = "Recipient";
const _RD = "RotationDate";
const _RE = "ReEncrypt";
const _RER = "ReEncryptRequest";
const _RERe = "ReEncryptResponse";
const _RG = "RetireGrant";
const _RGR = "RetireGrantRequest";
const _RGRe = "RevokeGrantRequest";
const _RGe = "RevokeGrant";
const _RI = "RecipientInfo";
const _RK = "ReplicaKeys";
const _RKM = "ReplicaKeyMetadata";
const _RKOD = "RotateKeyOnDemand";
const _RKODR = "RotateKeyOnDemandRequest";
const _RKODRo = "RotateKeyOnDemandResponse";
const _RKR = "ReplicateKeyRequest";
const _RKRe = "ReplicateKeyResponse";
const _RKe = "ReplicateKey";
const _RL = "RotationsList";
const _RLE = "RotationsListEntry";
const _RP = "RetiringPrincipal";
const _RPID = "RotationPeriodInDays";
const _RPe = "ReplicaPolicy";
const _RR = "ReplicaRegion";
const _RSAK = "RawSecretAccessKey";
const _RT = "ReplicaTags";
const _RTo = "RotationType";
const _Re = "Region";
const _Ro = "Rotations";
const _S = "Signature";
const _SA = "SigningAlgorithms";
const _SAi = "SigningAlgorithm";
const _SEA = "SourceEncryptionAlgorithm";
const _SEC = "SourceEncryptionContext";
const _SKD = "ScheduleKeyDeletion";
const _SKDR = "ScheduleKeyDeletionRequest";
const _SKDRc = "ScheduleKeyDeletionResponse";
const _SKI = "SourceKeyId";
const _SKMI = "SourceKeyMaterialId";
const _SR = "SignRequest";
const _SRi = "SignResponse";
const _SS = "SharedSecret";
const _SV = "SignatureValid";
const _Si = "Sign";
const _T = "Tags";
const _TAC = "TrustAnchorCertificate";
const _TE = "TagException";
const _TK = "TagKey";
const _TKI = "TargetKeyId";
const _TKa = "TagKeys";
const _TL = "TagList";
const _TR = "TagResource";
const _TRR = "TagResourceRequest";
const _TV = "TagValue";
const _Ta = "Tag";
const _Tr = "Truncated";
const _UA = "UpdateAlias";
const _UAR = "UpdateAliasRequest";
const _UCKS = "UpdateCustomKeyStore";
const _UCKSR = "UpdateCustomKeyStoreRequest";
const _UCKSRp = "UpdateCustomKeyStoreResponse";
const _UE = "UriEndpoint";
const _UKD = "UpdateKeyDescription";
const _UKDR = "UpdateKeyDescriptionRequest";
const _UOE = "UnsupportedOperationException";
const _UP = "UriPath";
const _UPR = "UpdatePrimaryRegion";
const _UPRR = "UpdatePrimaryRegionRequest";
const _UR = "UntagResource";
const _URR = "UntagResourceRequest";
const _V = "Verify";
const _VESN = "VpcEndpointServiceName";
const _VESO = "VpcEndpointServiceOwner";
const _VM = "VerifyMac";
const _VMR = "VerifyMacRequest";
const _VMRe = "VerifyMacResponse";
const _VR = "VerifyRequest";
const _VRe = "VerifyResponse";
const _VT = "ValidTo";
const _WA = "WrappingAlgorithm";
const _WKS = "WrappingKeySpec";
const _XKAIUE = "XksKeyAlreadyInUseException";
const _XKC = "XksKeyConfiguration";
const _XKCT = "XksKeyConfigurationType";
const _XKI = "XksKeyId";
const _XKICE = "XksKeyInvalidConfigurationException";
const _XKNFE = "XksKeyNotFoundException";
const _XPAAKIT = "XksProxyAuthenticationAccessKeyIdType";
const _XPAC = "XksProxyAuthenticationCredential";
const _XPACT = "XksProxyAuthenticationCredentialType";
const _XPARSAKT = "XksProxyAuthenticationRawSecretAccessKeyType";
const _XPC = "XksProxyConnectivity";
const _XPCT = "XksProxyConfigurationType";
const _XPCk = "XksProxyConfiguration";
const _XPIACE = "XksProxyIncorrectAuthenticationCredentialException";
const _XPICE = "XksProxyInvalidConfigurationException";
const _XPIRE = "XksProxyInvalidResponseException";
const _XPUE = "XksProxyUriEndpoint";
const _XPUEIUE = "XksProxyUriEndpointInUseException";
const _XPUIUE = "XksProxyUriInUseException";
const _XPUP = "XksProxyUriPath";
const _XPUUE = "XksProxyUriUnreachableException";
const _XPVESICE = "XksProxyVpcEndpointServiceInvalidConfigurationException";
const _XPVESIUE = "XksProxyVpcEndpointServiceInUseException";
const _XPVESN = "XksProxyVpcEndpointServiceName";
const _XPVESNFE = "XksProxyVpcEndpointServiceNotFoundException";
const _XPVESO = "XksProxyVpcEndpointServiceOwner";
const _aQE = "awsQueryError";
const _c = "client";
const _e = "error";
const _hE = "httpError";
const _m = "message";
const _s = "server";
const _sm = "smithy.ts.sdk.synthetic.com.amazonaws.kms";
const n0 = "com.amazonaws.kms";
import { TypeRegistry } from "@smithy/core/schema";
import { AlreadyExistsException, CloudHsmClusterInUseException, CloudHsmClusterInvalidConfigurationException, CloudHsmClusterNotActiveException, CloudHsmClusterNotFoundException, CloudHsmClusterNotRelatedException, ConflictException, CustomKeyStoreHasCMKsException, CustomKeyStoreInvalidStateException, CustomKeyStoreNameInUseException, CustomKeyStoreNotFoundException, DependencyTimeoutException, DisabledException, DryRunOperationException, ExpiredImportTokenException, IncorrectKeyException, IncorrectKeyMaterialException, IncorrectTrustAnchorException, InvalidAliasNameException, InvalidArnException, InvalidCiphertextException, InvalidGrantIdException, InvalidGrantTokenException, InvalidImportTokenException, InvalidKeyUsageException, InvalidMarkerException, KeyUnavailableException, KMSInternalException, KMSInvalidMacException, KMSInvalidSignatureException, KMSInvalidStateException, LimitExceededException, MalformedPolicyDocumentException, NotFoundException, TagException, UnsupportedOperationException, XksKeyAlreadyInUseException, XksKeyInvalidConfigurationException, XksKeyNotFoundException, XksProxyIncorrectAuthenticationCredentialException, XksProxyInvalidConfigurationException, XksProxyInvalidResponseException, XksProxyUriEndpointInUseException, XksProxyUriInUseException, XksProxyUriUnreachableException, XksProxyVpcEndpointServiceInUseException, XksProxyVpcEndpointServiceInvalidConfigurationException, XksProxyVpcEndpointServiceNotFoundException, } from "../models/errors";
import { KMSServiceException } from "../models/KMSServiceException";
var KeyStorePasswordType = [0, n0, _KSPT, 8, 0];
var PlaintextType = [0, n0, _PT, 8, 21];
var XksProxyAuthenticationAccessKeyIdType = [0, n0, _XPAAKIT, 8, 0];
var XksProxyAuthenticationRawSecretAccessKeyType = [0, n0, _XPARSAKT, 8, 0];
export var AliasListEntry$ = [3, n0, _ALE,
    0,
    [_AN, _AA, _TKI, _CD, _LUD],
    [0, 0, 0, 4, 4]
];
export var AlreadyExistsException$ = [-3, n0, _AEE,
    { [_aQE]: [`AlreadyExists`, 409], [_e]: _c, [_hE]: 409 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(AlreadyExistsException$, AlreadyExistsException);
export var CancelKeyDeletionRequest$ = [3, n0, _CKDR,
    0,
    [_KI],
    [0], 1
];
export var CancelKeyDeletionResponse$ = [3, n0, _CKDRa,
    0,
    [_KI],
    [0]
];
export var CloudHsmClusterInUseException$ = [-3, n0, _CHCIUE,
    { [_aQE]: [`CloudHsmClusterInUseException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(CloudHsmClusterInUseException$, CloudHsmClusterInUseException);
export var CloudHsmClusterInvalidConfigurationException$ = [-3, n0, _CHCICE,
    { [_aQE]: [`CloudHsmClusterInvalidConfigurationException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(CloudHsmClusterInvalidConfigurationException$, CloudHsmClusterInvalidConfigurationException);
export var CloudHsmClusterNotActiveException$ = [-3, n0, _CHCNAE,
    { [_aQE]: [`CloudHsmClusterNotActiveException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(CloudHsmClusterNotActiveException$, CloudHsmClusterNotActiveException);
export var CloudHsmClusterNotFoundException$ = [-3, n0, _CHCNFE,
    { [_aQE]: [`CloudHsmClusterNotFoundException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(CloudHsmClusterNotFoundException$, CloudHsmClusterNotFoundException);
export var CloudHsmClusterNotRelatedException$ = [-3, n0, _CHCNRE,
    { [_aQE]: [`CloudHsmClusterNotRelatedException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(CloudHsmClusterNotRelatedException$, CloudHsmClusterNotRelatedException);
export var ConflictException$ = [-3, n0, _CE,
    { [_aQE]: [`ConflictException`, 409], [_e]: _c, [_hE]: 409 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(ConflictException$, ConflictException);
export var ConnectCustomKeyStoreRequest$ = [3, n0, _CCKSR,
    0,
    [_CKSI],
    [0], 1
];
export var ConnectCustomKeyStoreResponse$ = [3, n0, _CCKSRo,
    0,
    [],
    []
];
export var CreateAliasRequest$ = [3, n0, _CAR,
    0,
    [_AN, _TKI],
    [0, 0], 2
];
export var CreateCustomKeyStoreRequest$ = [3, n0, _CCKSRr,
    0,
    [_CKSN, _CHCI, _TAC, _KSP, _CKST, _XPUE, _XPUP, _XPVESN, _XPVESO, _XPAC, _XPC],
    [0, 0, 0, [() => KeyStorePasswordType, 0], 0, 0, 0, 0, 0, [() => XksProxyAuthenticationCredentialType$, 0], 0], 1
];
export var CreateCustomKeyStoreResponse$ = [3, n0, _CCKSRre,
    0,
    [_CKSI],
    [0]
];
export var CreateGrantRequest$ = [3, n0, _CGR,
    0,
    [_KI, _GP, _O, _RP, _C, _GT, _N, _DR],
    [0, 0, 64 | 0, 0, () => GrantConstraints$, 64 | 0, 0, 2], 3
];
export var CreateGrantResponse$ = [3, n0, _CGRr,
    0,
    [_GTr, _GI],
    [0, 0]
];
export var CreateKeyRequest$ = [3, n0, _CKR,
    0,
    [_P, _D, _KU, _CMKS, _KS, _Or, _CKSI, _BPLSC, _T, _MR, _XKI],
    [0, 0, 0, 0, 0, 0, 0, 2, () => TagList, 2, 0]
];
export var CreateKeyResponse$ = [3, n0, _CKRr,
    0,
    [_KM],
    [() => KeyMetadata$]
];
export var CustomKeyStoreHasCMKsException$ = [-3, n0, _CKSHCMKE,
    { [_aQE]: [`CustomKeyStoreHasCMKsException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(CustomKeyStoreHasCMKsException$, CustomKeyStoreHasCMKsException);
export var CustomKeyStoreInvalidStateException$ = [-3, n0, _CKSISE,
    { [_aQE]: [`CustomKeyStoreInvalidStateException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(CustomKeyStoreInvalidStateException$, CustomKeyStoreInvalidStateException);
export var CustomKeyStoreNameInUseException$ = [-3, n0, _CKSNIUE,
    { [_aQE]: [`CustomKeyStoreNameInUseException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(CustomKeyStoreNameInUseException$, CustomKeyStoreNameInUseException);
export var CustomKeyStoreNotFoundException$ = [-3, n0, _CKSNFE,
    { [_aQE]: [`CustomKeyStoreNotFoundException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(CustomKeyStoreNotFoundException$, CustomKeyStoreNotFoundException);
export var CustomKeyStoresListEntry$ = [3, n0, _CKSLE,
    0,
    [_CKSI, _CKSN, _CHCI, _TAC, _CS, _CEC, _CD, _CKST, _XPCk],
    [0, 0, 0, 0, 0, 0, 4, 0, [() => XksProxyConfigurationType$, 0]]
];
export var DecryptRequest$ = [3, n0, _DRe,
    0,
    [_CB, _EC, _GT, _KI, _EA, _R, _DR],
    [21, 128 | 0, 64 | 0, 0, 0, () => RecipientInfo$, 2], 1
];
export var DecryptResponse$ = [3, n0, _DRec,
    0,
    [_KI, _Pl, _EA, _CFR, _KMI],
    [0, [() => PlaintextType, 0], 0, 21, 0]
];
export var DeleteAliasRequest$ = [3, n0, _DAR,
    0,
    [_AN],
    [0], 1
];
export var DeleteCustomKeyStoreRequest$ = [3, n0, _DCKSR,
    0,
    [_CKSI],
    [0], 1
];
export var DeleteCustomKeyStoreResponse$ = [3, n0, _DCKSRe,
    0,
    [],
    []
];
export var DeleteImportedKeyMaterialRequest$ = [3, n0, _DIKMR,
    0,
    [_KI, _KMI],
    [0, 0], 1
];
export var DeleteImportedKeyMaterialResponse$ = [3, n0, _DIKMRe,
    0,
    [_KI, _KMI],
    [0, 0]
];
export var DependencyTimeoutException$ = [-3, n0, _DTE,
    { [_aQE]: [`DependencyTimeout`, 503], [_e]: _s, [_hE]: 503 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(DependencyTimeoutException$, DependencyTimeoutException);
export var DeriveSharedSecretRequest$ = [3, n0, _DSSR,
    0,
    [_KI, _KAA, _PK, _GT, _DR, _R],
    [0, 0, 21, 64 | 0, 2, () => RecipientInfo$], 3
];
export var DeriveSharedSecretResponse$ = [3, n0, _DSSRe,
    0,
    [_KI, _SS, _CFR, _KAA, _KO],
    [0, [() => PlaintextType, 0], 21, 0, 0]
];
export var DescribeCustomKeyStoresRequest$ = [3, n0, _DCKSRes,
    0,
    [_CKSI, _CKSN, _L, _M],
    [0, 0, 1, 0]
];
export var DescribeCustomKeyStoresResponse$ = [3, n0, _DCKSResc,
    0,
    [_CKS, _NM, _Tr],
    [[() => CustomKeyStoresList, 0], 0, 2]
];
export var DescribeKeyRequest$ = [3, n0, _DKR,
    0,
    [_KI, _GT],
    [0, 64 | 0], 1
];
export var DescribeKeyResponse$ = [3, n0, _DKRe,
    0,
    [_KM],
    [() => KeyMetadata$]
];
export var DisabledException$ = [-3, n0, _DE,
    { [_aQE]: [`Disabled`, 409], [_e]: _c, [_hE]: 409 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(DisabledException$, DisabledException);
export var DisableKeyRequest$ = [3, n0, _DKRi,
    0,
    [_KI],
    [0], 1
];
export var DisableKeyRotationRequest$ = [3, n0, _DKRR,
    0,
    [_KI],
    [0], 1
];
export var DisconnectCustomKeyStoreRequest$ = [3, n0, _DCKSRi,
    0,
    [_CKSI],
    [0], 1
];
export var DisconnectCustomKeyStoreResponse$ = [3, n0, _DCKSRis,
    0,
    [],
    []
];
export var DryRunOperationException$ = [-3, n0, _DROE,
    { [_aQE]: [`DryRunOperation`, 412], [_e]: _c, [_hE]: 412 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(DryRunOperationException$, DryRunOperationException);
export var EnableKeyRequest$ = [3, n0, _EKR,
    0,
    [_KI],
    [0], 1
];
export var EnableKeyRotationRequest$ = [3, n0, _EKRR,
    0,
    [_KI, _RPID],
    [0, 1], 1
];
export var EncryptRequest$ = [3, n0, _ER,
    0,
    [_KI, _Pl, _EC, _GT, _EA, _DR],
    [0, [() => PlaintextType, 0], 128 | 0, 64 | 0, 0, 2], 2
];
export var EncryptResponse$ = [3, n0, _ERn,
    0,
    [_CB, _KI, _EA],
    [21, 0, 0]
];
export var ExpiredImportTokenException$ = [-3, n0, _EITE,
    { [_aQE]: [`ExpiredImportTokenException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(ExpiredImportTokenException$, ExpiredImportTokenException);
export var GenerateDataKeyPairRequest$ = [3, n0, _GDKPR,
    0,
    [_KI, _KPS, _EC, _GT, _R, _DR],
    [0, 0, 128 | 0, 64 | 0, () => RecipientInfo$, 2], 2
];
export var GenerateDataKeyPairResponse$ = [3, n0, _GDKPRe,
    0,
    [_PKCB, _PKP, _PK, _KI, _KPS, _CFR, _KMI],
    [21, [() => PlaintextType, 0], 21, 0, 0, 21, 0]
];
export var GenerateDataKeyPairWithoutPlaintextRequest$ = [3, n0, _GDKPWPR,
    0,
    [_KI, _KPS, _EC, _GT, _DR],
    [0, 0, 128 | 0, 64 | 0, 2], 2
];
export var GenerateDataKeyPairWithoutPlaintextResponse$ = [3, n0, _GDKPWPRe,
    0,
    [_PKCB, _PK, _KI, _KPS, _KMI],
    [21, 21, 0, 0, 0]
];
export var GenerateDataKeyRequest$ = [3, n0, _GDKR,
    0,
    [_KI, _EC, _NOB, _KS, _GT, _R, _DR],
    [0, 128 | 0, 1, 0, 64 | 0, () => RecipientInfo$, 2], 1
];
export var GenerateDataKeyResponse$ = [3, n0, _GDKRe,
    0,
    [_CB, _Pl, _KI, _CFR, _KMI],
    [21, [() => PlaintextType, 0], 0, 21, 0]
];
export var GenerateDataKeyWithoutPlaintextRequest$ = [3, n0, _GDKWPR,
    0,
    [_KI, _EC, _KS, _NOB, _GT, _DR],
    [0, 128 | 0, 0, 1, 64 | 0, 2], 1
];
export var GenerateDataKeyWithoutPlaintextResponse$ = [3, n0, _GDKWPRe,
    0,
    [_CB, _KI, _KMI],
    [21, 0, 0]
];
export var GenerateMacRequest$ = [3, n0, _GMR,
    0,
    [_Me, _KI, _MA, _GT, _DR],
    [[() => PlaintextType, 0], 0, 0, 64 | 0, 2], 3
];
export var GenerateMacResponse$ = [3, n0, _GMRe,
    0,
    [_Ma, _MA, _KI],
    [21, 0, 0]
];
export var GenerateRandomRequest$ = [3, n0, _GRR,
    0,
    [_NOB, _CKSI, _R],
    [1, 0, () => RecipientInfo$]
];
export var GenerateRandomResponse$ = [3, n0, _GRRe,
    0,
    [_Pl, _CFR],
    [[() => PlaintextType, 0], 21]
];
export var GetKeyPolicyRequest$ = [3, n0, _GKPR,
    0,
    [_KI, _PN],
    [0, 0], 1
];
export var GetKeyPolicyResponse$ = [3, n0, _GKPRe,
    0,
    [_P, _PN],
    [0, 0]
];
export var GetKeyRotationStatusRequest$ = [3, n0, _GKRSR,
    0,
    [_KI],
    [0], 1
];
export var GetKeyRotationStatusResponse$ = [3, n0, _GKRSRe,
    0,
    [_KRE, _KI, _RPID, _NRD, _ODRSD],
    [2, 0, 1, 4, 4]
];
export var GetParametersForImportRequest$ = [3, n0, _GPFIR,
    0,
    [_KI, _WA, _WKS],
    [0, 0, 0], 3
];
export var GetParametersForImportResponse$ = [3, n0, _GPFIRe,
    0,
    [_KI, _IT, _PK, _PVT],
    [0, 21, [() => PlaintextType, 0], 4]
];
export var GetPublicKeyRequest$ = [3, n0, _GPKR,
    0,
    [_KI, _GT],
    [0, 64 | 0], 1
];
export var GetPublicKeyResponse$ = [3, n0, _GPKRe,
    0,
    [_KI, _PK, _CMKS, _KS, _KU, _EAn, _SA, _KAAe],
    [0, 21, 0, 0, 0, 64 | 0, 64 | 0, 64 | 0]
];
export var GrantConstraints$ = [3, n0, _GC,
    0,
    [_ECS, _ECE],
    [128 | 0, 128 | 0]
];
export var GrantListEntry$ = [3, n0, _GLE,
    0,
    [_KI, _GI, _N, _CD, _GP, _RP, _IA, _O, _C],
    [0, 0, 0, 4, 0, 0, 0, 64 | 0, () => GrantConstraints$]
];
export var ImportKeyMaterialRequest$ = [3, n0, _IKMR,
    0,
    [_KI, _IT, _EKM, _VT, _EM, _ITm, _KMD, _KMI],
    [0, 21, 21, 4, 0, 0, 0, 0], 3
];
export var ImportKeyMaterialResponse$ = [3, n0, _IKMRm,
    0,
    [_KI, _KMI],
    [0, 0]
];
export var IncorrectKeyException$ = [-3, n0, _IKE,
    { [_aQE]: [`IncorrectKeyException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(IncorrectKeyException$, IncorrectKeyException);
export var IncorrectKeyMaterialException$ = [-3, n0, _IKME,
    { [_aQE]: [`IncorrectKeyMaterialException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(IncorrectKeyMaterialException$, IncorrectKeyMaterialException);
export var IncorrectTrustAnchorException$ = [-3, n0, _ITAE,
    { [_aQE]: [`IncorrectTrustAnchorException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(IncorrectTrustAnchorException$, IncorrectTrustAnchorException);
export var InvalidAliasNameException$ = [-3, n0, _IANE,
    { [_aQE]: [`InvalidAliasName`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(InvalidAliasNameException$, InvalidAliasNameException);
export var InvalidArnException$ = [-3, n0, _IAE,
    { [_aQE]: [`InvalidArn`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(InvalidArnException$, InvalidArnException);
export var InvalidCiphertextException$ = [-3, n0, _ICE,
    { [_aQE]: [`InvalidCiphertext`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(InvalidCiphertextException$, InvalidCiphertextException);
export var InvalidGrantIdException$ = [-3, n0, _IGIE,
    { [_aQE]: [`InvalidGrantId`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(InvalidGrantIdException$, InvalidGrantIdException);
export var InvalidGrantTokenException$ = [-3, n0, _IGTE,
    { [_aQE]: [`InvalidGrantToken`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(InvalidGrantTokenException$, InvalidGrantTokenException);
export var InvalidImportTokenException$ = [-3, n0, _IITE,
    { [_aQE]: [`InvalidImportTokenException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(InvalidImportTokenException$, InvalidImportTokenException);
export var InvalidKeyUsageException$ = [-3, n0, _IKUE,
    { [_aQE]: [`InvalidKeyUsage`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(InvalidKeyUsageException$, InvalidKeyUsageException);
export var InvalidMarkerException$ = [-3, n0, _IME,
    { [_aQE]: [`InvalidMarker`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(InvalidMarkerException$, InvalidMarkerException);
export var KeyListEntry$ = [3, n0, _KLE,
    0,
    [_KI, _KA],
    [0, 0]
];
export var KeyMetadata$ = [3, n0, _KM,
    0,
    [_KI, _AWSAI, _A, _CD, _E, _D, _KU, _KSe, _DD, _VT, _Or, _CKSI, _CHCI, _EM, _KMe, _CMKS, _KS, _EAn, _SA, _KAAe, _MR, _MRC, _PDWID, _MAa, _XKC, _CKMI],
    [0, 0, 0, 4, 2, 0, 0, 0, 4, 4, 0, 0, 0, 0, 0, 0, 0, 64 | 0, 64 | 0, 64 | 0, 2, () => MultiRegionConfiguration$, 1, 64 | 0, () => XksKeyConfigurationType$, 0], 1
];
export var KeyUnavailableException$ = [-3, n0, _KUE,
    { [_aQE]: [`KeyUnavailable`, 500], [_e]: _s, [_hE]: 500 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(KeyUnavailableException$, KeyUnavailableException);
export var KMSInternalException$ = [-3, n0, _KMSIE,
    { [_aQE]: [`KMSInternal`, 500], [_e]: _s, [_hE]: 500 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(KMSInternalException$, KMSInternalException);
export var KMSInvalidMacException$ = [-3, n0, _KMSIME,
    { [_aQE]: [`KMSInvalidMac`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(KMSInvalidMacException$, KMSInvalidMacException);
export var KMSInvalidSignatureException$ = [-3, n0, _KMSISE,
    { [_aQE]: [`KMSInvalidSignature`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(KMSInvalidSignatureException$, KMSInvalidSignatureException);
export var KMSInvalidStateException$ = [-3, n0, _KMSISEn,
    { [_aQE]: [`KMSInvalidStateException`, 409], [_e]: _c, [_hE]: 409 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(KMSInvalidStateException$, KMSInvalidStateException);
export var LimitExceededException$ = [-3, n0, _LEE,
    { [_aQE]: [`LimitExceeded`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(LimitExceededException$, LimitExceededException);
export var ListAliasesRequest$ = [3, n0, _LAR,
    0,
    [_KI, _L, _M],
    [0, 1, 0]
];
export var ListAliasesResponse$ = [3, n0, _LARi,
    0,
    [_Al, _NM, _Tr],
    [() => AliasList, 0, 2]
];
export var ListGrantsRequest$ = [3, n0, _LGR,
    0,
    [_KI, _L, _M, _GI, _GP],
    [0, 1, 0, 0, 0], 1
];
export var ListGrantsResponse$ = [3, n0, _LGRi,
    0,
    [_G, _NM, _Tr],
    [() => GrantList, 0, 2]
];
export var ListKeyPoliciesRequest$ = [3, n0, _LKPR,
    0,
    [_KI, _L, _M],
    [0, 1, 0], 1
];
export var ListKeyPoliciesResponse$ = [3, n0, _LKPRi,
    0,
    [_PNo, _NM, _Tr],
    [64 | 0, 0, 2]
];
export var ListKeyRotationsRequest$ = [3, n0, _LKRR,
    0,
    [_KI, _IKM, _L, _M],
    [0, 0, 1, 0], 1
];
export var ListKeyRotationsResponse$ = [3, n0, _LKRRi,
    0,
    [_Ro, _NM, _Tr],
    [() => RotationsList, 0, 2]
];
export var ListKeysRequest$ = [3, n0, _LKR,
    0,
    [_L, _M],
    [1, 0]
];
export var ListKeysResponse$ = [3, n0, _LKRi,
    0,
    [_K, _NM, _Tr],
    [() => KeyList, 0, 2]
];
export var ListResourceTagsRequest$ = [3, n0, _LRTR,
    0,
    [_KI, _L, _M],
    [0, 1, 0], 1
];
export var ListResourceTagsResponse$ = [3, n0, _LRTRi,
    0,
    [_T, _NM, _Tr],
    [() => TagList, 0, 2]
];
export var ListRetirableGrantsRequest$ = [3, n0, _LRGR,
    0,
    [_RP, _L, _M],
    [0, 1, 0], 1
];
export var MalformedPolicyDocumentException$ = [-3, n0, _MPDE,
    { [_aQE]: [`MalformedPolicyDocument`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(MalformedPolicyDocumentException$, MalformedPolicyDocumentException);
export var MultiRegionConfiguration$ = [3, n0, _MRC,
    0,
    [_MRKT, _PKr, _RK],
    [0, () => MultiRegionKey$, () => MultiRegionKeyList]
];
export var MultiRegionKey$ = [3, n0, _MRK,
    0,
    [_A, _Re],
    [0, 0]
];
export var NotFoundException$ = [-3, n0, _NFE,
    { [_aQE]: [`NotFound`, 404], [_e]: _c, [_hE]: 404 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(NotFoundException$, NotFoundException);
export var PutKeyPolicyRequest$ = [3, n0, _PKPR,
    0,
    [_KI, _P, _PN, _BPLSC],
    [0, 0, 0, 2], 2
];
export var RecipientInfo$ = [3, n0, _RI,
    0,
    [_KEA, _AD],
    [0, 21]
];
export var ReEncryptRequest$ = [3, n0, _RER,
    0,
    [_CB, _DKI, _SEC, _SKI, _DEC, _SEA, _DEA, _GT, _DR],
    [21, 0, 128 | 0, 0, 128 | 0, 0, 0, 64 | 0, 2], 2
];
export var ReEncryptResponse$ = [3, n0, _RERe,
    0,
    [_CB, _SKI, _KI, _SEA, _DEA, _SKMI, _DKMI],
    [21, 0, 0, 0, 0, 0, 0]
];
export var ReplicateKeyRequest$ = [3, n0, _RKR,
    0,
    [_KI, _RR, _P, _BPLSC, _D, _T],
    [0, 0, 0, 2, 0, () => TagList], 2
];
export var ReplicateKeyResponse$ = [3, n0, _RKRe,
    0,
    [_RKM, _RPe, _RT],
    [() => KeyMetadata$, 0, () => TagList]
];
export var RetireGrantRequest$ = [3, n0, _RGR,
    0,
    [_GTr, _KI, _GI, _DR],
    [0, 0, 0, 2]
];
export var RevokeGrantRequest$ = [3, n0, _RGRe,
    0,
    [_KI, _GI, _DR],
    [0, 0, 2], 2
];
export var RotateKeyOnDemandRequest$ = [3, n0, _RKODR,
    0,
    [_KI],
    [0], 1
];
export var RotateKeyOnDemandResponse$ = [3, n0, _RKODRo,
    0,
    [_KI],
    [0]
];
export var RotationsListEntry$ = [3, n0, _RLE,
    0,
    [_KI, _KMI, _KMD, _IS, _KMS, _EM, _VT, _RD, _RTo],
    [0, 0, 0, 0, 0, 0, 4, 4, 0]
];
export var ScheduleKeyDeletionRequest$ = [3, n0, _SKDR,
    0,
    [_KI, _PWID],
    [0, 1], 1
];
export var ScheduleKeyDeletionResponse$ = [3, n0, _SKDRc,
    0,
    [_KI, _DD, _KSe, _PWID],
    [0, 4, 0, 1]
];
export var SignRequest$ = [3, n0, _SR,
    0,
    [_KI, _Me, _SAi, _MT, _GT, _DR],
    [0, [() => PlaintextType, 0], 0, 0, 64 | 0, 2], 3
];
export var SignResponse$ = [3, n0, _SRi,
    0,
    [_KI, _S, _SAi],
    [0, 21, 0]
];
export var Tag$ = [3, n0, _Ta,
    0,
    [_TK, _TV],
    [0, 0], 2
];
export var TagException$ = [-3, n0, _TE,
    { [_aQE]: [`TagException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(TagException$, TagException);
export var TagResourceRequest$ = [3, n0, _TRR,
    0,
    [_KI, _T],
    [0, () => TagList], 2
];
export var UnsupportedOperationException$ = [-3, n0, _UOE,
    { [_aQE]: [`UnsupportedOperation`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(UnsupportedOperationException$, UnsupportedOperationException);
export var UntagResourceRequest$ = [3, n0, _URR,
    0,
    [_KI, _TKa],
    [0, 64 | 0], 2
];
export var UpdateAliasRequest$ = [3, n0, _UAR,
    0,
    [_AN, _TKI],
    [0, 0], 2
];
export var UpdateCustomKeyStoreRequest$ = [3, n0, _UCKSR,
    0,
    [_CKSI, _NCKSN, _KSP, _CHCI, _XPUE, _XPUP, _XPVESN, _XPVESO, _XPAC, _XPC],
    [0, 0, [() => KeyStorePasswordType, 0], 0, 0, 0, 0, 0, [() => XksProxyAuthenticationCredentialType$, 0], 0], 1
];
export var UpdateCustomKeyStoreResponse$ = [3, n0, _UCKSRp,
    0,
    [],
    []
];
export var UpdateKeyDescriptionRequest$ = [3, n0, _UKDR,
    0,
    [_KI, _D],
    [0, 0], 2
];
export var UpdatePrimaryRegionRequest$ = [3, n0, _UPRR,
    0,
    [_KI, _PR],
    [0, 0], 2
];
export var VerifyMacRequest$ = [3, n0, _VMR,
    0,
    [_Me, _KI, _MA, _Ma, _GT, _DR],
    [[() => PlaintextType, 0], 0, 0, 21, 64 | 0, 2], 4
];
export var VerifyMacResponse$ = [3, n0, _VMRe,
    0,
    [_KI, _MV, _MA],
    [0, 2, 0]
];
export var VerifyRequest$ = [3, n0, _VR,
    0,
    [_KI, _Me, _S, _SAi, _MT, _GT, _DR],
    [0, [() => PlaintextType, 0], 21, 0, 0, 64 | 0, 2], 4
];
export var VerifyResponse$ = [3, n0, _VRe,
    0,
    [_KI, _SV, _SAi],
    [0, 2, 0]
];
export var XksKeyAlreadyInUseException$ = [-3, n0, _XKAIUE,
    { [_aQE]: [`XksKeyAlreadyInUse`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(XksKeyAlreadyInUseException$, XksKeyAlreadyInUseException);
export var XksKeyConfigurationType$ = [3, n0, _XKCT,
    0,
    [_I],
    [0]
];
export var XksKeyInvalidConfigurationException$ = [-3, n0, _XKICE,
    { [_aQE]: [`XksKeyInvalidConfiguration`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(XksKeyInvalidConfigurationException$, XksKeyInvalidConfigurationException);
export var XksKeyNotFoundException$ = [-3, n0, _XKNFE,
    { [_aQE]: [`XksKeyNotFoundException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(XksKeyNotFoundException$, XksKeyNotFoundException);
export var XksProxyAuthenticationCredentialType$ = [3, n0, _XPACT,
    0,
    [_AKI, _RSAK],
    [[() => XksProxyAuthenticationAccessKeyIdType, 0], [() => XksProxyAuthenticationRawSecretAccessKeyType, 0]], 2
];
export var XksProxyConfigurationType$ = [3, n0, _XPCT,
    0,
    [_Co, _AKI, _UE, _UP, _VESN, _VESO],
    [0, [() => XksProxyAuthenticationAccessKeyIdType, 0], 0, 0, 0, 0]
];
export var XksProxyIncorrectAuthenticationCredentialException$ = [-3, n0, _XPIACE,
    { [_aQE]: [`XksProxyIncorrectAuthenticationCredentialException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(XksProxyIncorrectAuthenticationCredentialException$, XksProxyIncorrectAuthenticationCredentialException);
export var XksProxyInvalidConfigurationException$ = [-3, n0, _XPICE,
    { [_aQE]: [`XksProxyInvalidConfigurationException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(XksProxyInvalidConfigurationException$, XksProxyInvalidConfigurationException);
export var XksProxyInvalidResponseException$ = [-3, n0, _XPIRE,
    { [_aQE]: [`XksProxyInvalidResponseException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(XksProxyInvalidResponseException$, XksProxyInvalidResponseException);
export var XksProxyUriEndpointInUseException$ = [-3, n0, _XPUEIUE,
    { [_aQE]: [`XksProxyUriEndpointInUseException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(XksProxyUriEndpointInUseException$, XksProxyUriEndpointInUseException);
export var XksProxyUriInUseException$ = [-3, n0, _XPUIUE,
    { [_aQE]: [`XksProxyUriInUseException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(XksProxyUriInUseException$, XksProxyUriInUseException);
export var XksProxyUriUnreachableException$ = [-3, n0, _XPUUE,
    { [_aQE]: [`XksProxyUriUnreachableException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(XksProxyUriUnreachableException$, XksProxyUriUnreachableException);
export var XksProxyVpcEndpointServiceInUseException$ = [-3, n0, _XPVESIUE,
    { [_aQE]: [`XksProxyVpcEndpointServiceInUseException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(XksProxyVpcEndpointServiceInUseException$, XksProxyVpcEndpointServiceInUseException);
export var XksProxyVpcEndpointServiceInvalidConfigurationException$ = [-3, n0, _XPVESICE,
    { [_aQE]: [`XksProxyVpcEndpointServiceInvalidConfigurationException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(XksProxyVpcEndpointServiceInvalidConfigurationException$, XksProxyVpcEndpointServiceInvalidConfigurationException);
export var XksProxyVpcEndpointServiceNotFoundException$ = [-3, n0, _XPVESNFE,
    { [_aQE]: [`XksProxyVpcEndpointServiceNotFoundException`, 400], [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
TypeRegistry.for(n0).registerError(XksProxyVpcEndpointServiceNotFoundException$, XksProxyVpcEndpointServiceNotFoundException);
var __Unit = "unit";
export var KMSServiceException$ = [-3, _sm, "KMSServiceException", 0, [], []];
TypeRegistry.for(_sm).registerError(KMSServiceException$, KMSServiceException);
var AliasList = [1, n0, _AL,
    0, () => AliasListEntry$
];
var CustomKeyStoresList = [1, n0, _CKSL,
    0, [() => CustomKeyStoresListEntry$,
        0]
];
var EncryptionAlgorithmSpecList = 64 | 0;
var GrantList = [1, n0, _GL,
    0, () => GrantListEntry$
];
var GrantOperationList = 64 | 0;
var GrantTokenList = 64 | 0;
var KeyAgreementAlgorithmSpecList = 64 | 0;
var KeyList = [1, n0, _KL,
    0, () => KeyListEntry$
];
var MacAlgorithmSpecList = 64 | 0;
var MultiRegionKeyList = [1, n0, _MRKL,
    0, () => MultiRegionKey$
];
var PolicyNameList = 64 | 0;
var RotationsList = [1, n0, _RL,
    0, () => RotationsListEntry$
];
var SigningAlgorithmSpecList = 64 | 0;
var TagKeyList = 64 | 0;
var TagList = [1, n0, _TL,
    0, () => Tag$
];
var EncryptionContextType = 128 | 0;
export var CancelKeyDeletion$ = [9, n0, _CKD,
    0, () => CancelKeyDeletionRequest$, () => CancelKeyDeletionResponse$
];
export var ConnectCustomKeyStore$ = [9, n0, _CCKS,
    0, () => ConnectCustomKeyStoreRequest$, () => ConnectCustomKeyStoreResponse$
];
export var CreateAlias$ = [9, n0, _CA,
    0, () => CreateAliasRequest$, () => __Unit
];
export var CreateCustomKeyStore$ = [9, n0, _CCKSr,
    0, () => CreateCustomKeyStoreRequest$, () => CreateCustomKeyStoreResponse$
];
export var CreateGrant$ = [9, n0, _CG,
    0, () => CreateGrantRequest$, () => CreateGrantResponse$
];
export var CreateKey$ = [9, n0, _CK,
    0, () => CreateKeyRequest$, () => CreateKeyResponse$
];
export var Decrypt$ = [9, n0, _De,
    0, () => DecryptRequest$, () => DecryptResponse$
];
export var DeleteAlias$ = [9, n0, _DA,
    0, () => DeleteAliasRequest$, () => __Unit
];
export var DeleteCustomKeyStore$ = [9, n0, _DCKS,
    0, () => DeleteCustomKeyStoreRequest$, () => DeleteCustomKeyStoreResponse$
];
export var DeleteImportedKeyMaterial$ = [9, n0, _DIKM,
    0, () => DeleteImportedKeyMaterialRequest$, () => DeleteImportedKeyMaterialResponse$
];
export var DeriveSharedSecret$ = [9, n0, _DSS,
    0, () => DeriveSharedSecretRequest$, () => DeriveSharedSecretResponse$
];
export var DescribeCustomKeyStores$ = [9, n0, _DCKSe,
    0, () => DescribeCustomKeyStoresRequest$, () => DescribeCustomKeyStoresResponse$
];
export var DescribeKey$ = [9, n0, _DK,
    0, () => DescribeKeyRequest$, () => DescribeKeyResponse$
];
export var DisableKey$ = [9, n0, _DKi,
    0, () => DisableKeyRequest$, () => __Unit
];
export var DisableKeyRotation$ = [9, n0, _DKRis,
    0, () => DisableKeyRotationRequest$, () => __Unit
];
export var DisconnectCustomKeyStore$ = [9, n0, _DCKSi,
    0, () => DisconnectCustomKeyStoreRequest$, () => DisconnectCustomKeyStoreResponse$
];
export var EnableKey$ = [9, n0, _EK,
    0, () => EnableKeyRequest$, () => __Unit
];
export var EnableKeyRotation$ = [9, n0, _EKRn,
    0, () => EnableKeyRotationRequest$, () => __Unit
];
export var Encrypt$ = [9, n0, _En,
    0, () => EncryptRequest$, () => EncryptResponse$
];
export var GenerateDataKey$ = [9, n0, _GDK,
    0, () => GenerateDataKeyRequest$, () => GenerateDataKeyResponse$
];
export var GenerateDataKeyPair$ = [9, n0, _GDKP,
    0, () => GenerateDataKeyPairRequest$, () => GenerateDataKeyPairResponse$
];
export var GenerateDataKeyPairWithoutPlaintext$ = [9, n0, _GDKPWP,
    0, () => GenerateDataKeyPairWithoutPlaintextRequest$, () => GenerateDataKeyPairWithoutPlaintextResponse$
];
export var GenerateDataKeyWithoutPlaintext$ = [9, n0, _GDKWP,
    0, () => GenerateDataKeyWithoutPlaintextRequest$, () => GenerateDataKeyWithoutPlaintextResponse$
];
export var GenerateMac$ = [9, n0, _GM,
    0, () => GenerateMacRequest$, () => GenerateMacResponse$
];
export var GenerateRandom$ = [9, n0, _GR,
    0, () => GenerateRandomRequest$, () => GenerateRandomResponse$
];
export var GetKeyPolicy$ = [9, n0, _GKP,
    0, () => GetKeyPolicyRequest$, () => GetKeyPolicyResponse$
];
export var GetKeyRotationStatus$ = [9, n0, _GKRS,
    0, () => GetKeyRotationStatusRequest$, () => GetKeyRotationStatusResponse$
];
export var GetParametersForImport$ = [9, n0, _GPFI,
    0, () => GetParametersForImportRequest$, () => GetParametersForImportResponse$
];
export var GetPublicKey$ = [9, n0, _GPK,
    0, () => GetPublicKeyRequest$, () => GetPublicKeyResponse$
];
export var ImportKeyMaterial$ = [9, n0, _IKMm,
    0, () => ImportKeyMaterialRequest$, () => ImportKeyMaterialResponse$
];
export var ListAliases$ = [9, n0, _LA,
    0, () => ListAliasesRequest$, () => ListAliasesResponse$
];
export var ListGrants$ = [9, n0, _LG,
    0, () => ListGrantsRequest$, () => ListGrantsResponse$
];
export var ListKeyPolicies$ = [9, n0, _LKP,
    0, () => ListKeyPoliciesRequest$, () => ListKeyPoliciesResponse$
];
export var ListKeyRotations$ = [9, n0, _LKRis,
    0, () => ListKeyRotationsRequest$, () => ListKeyRotationsResponse$
];
export var ListKeys$ = [9, n0, _LK,
    0, () => ListKeysRequest$, () => ListKeysResponse$
];
export var ListResourceTags$ = [9, n0, _LRT,
    0, () => ListResourceTagsRequest$, () => ListResourceTagsResponse$
];
export var ListRetirableGrants$ = [9, n0, _LRG,
    0, () => ListRetirableGrantsRequest$, () => ListGrantsResponse$
];
export var PutKeyPolicy$ = [9, n0, _PKPu,
    0, () => PutKeyPolicyRequest$, () => __Unit
];
export var ReEncrypt$ = [9, n0, _RE,
    0, () => ReEncryptRequest$, () => ReEncryptResponse$
];
export var ReplicateKey$ = [9, n0, _RKe,
    0, () => ReplicateKeyRequest$, () => ReplicateKeyResponse$
];
export var RetireGrant$ = [9, n0, _RG,
    0, () => RetireGrantRequest$, () => __Unit
];
export var RevokeGrant$ = [9, n0, _RGe,
    0, () => RevokeGrantRequest$, () => __Unit
];
export var RotateKeyOnDemand$ = [9, n0, _RKOD,
    0, () => RotateKeyOnDemandRequest$, () => RotateKeyOnDemandResponse$
];
export var ScheduleKeyDeletion$ = [9, n0, _SKD,
    0, () => ScheduleKeyDeletionRequest$, () => ScheduleKeyDeletionResponse$
];
export var Sign$ = [9, n0, _Si,
    0, () => SignRequest$, () => SignResponse$
];
export var TagResource$ = [9, n0, _TR,
    0, () => TagResourceRequest$, () => __Unit
];
export var UntagResource$ = [9, n0, _UR,
    0, () => UntagResourceRequest$, () => __Unit
];
export var UpdateAlias$ = [9, n0, _UA,
    0, () => UpdateAliasRequest$, () => __Unit
];
export var UpdateCustomKeyStore$ = [9, n0, _UCKS,
    0, () => UpdateCustomKeyStoreRequest$, () => UpdateCustomKeyStoreResponse$
];
export var UpdateKeyDescription$ = [9, n0, _UKD,
    0, () => UpdateKeyDescriptionRequest$, () => __Unit
];
export var UpdatePrimaryRegion$ = [9, n0, _UPR,
    0, () => UpdatePrimaryRegionRequest$, () => __Unit
];
export var Verify$ = [9, n0, _V,
    0, () => VerifyRequest$, () => VerifyResponse$
];
export var VerifyMac$ = [9, n0, _VM,
    0, () => VerifyMacRequest$, () => VerifyMacResponse$
];
